import React from 'react';
import {
  Dropdown,
  DropdownItem,
  Flex,
  Text,
  ThemeModePreference,
  useIsMobile,
  useThemeMode,
} from '@amzn/storm-ui';
import { chromeComponents } from 'src/constants';
import { useHeaderBundle } from 'src/providers/PantherLocalizationProvider';
import { StyledThemeModeTag as Tag } from '../styles';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';

const ThemeModesControl = () => {
  const { themeModePreference, setThemeMode } = useThemeMode();
  const isMobile = useIsMobile();
  const bundle = useHeaderBundle();

  return (
    <Flex direction="column" rowGap="xxsmall">
      <Text weight="bold">
        {bundle.getMessage('theme-modes-control-label')}
        <Tag label="Beta" />
      </Text>
      <Dropdown
        data-ccx-e2e-id="theme-modes-control"
        onChange={setThemeMode}
        selectedValue={themeModePreference}
        fullWidth={isMobile}
        small={!isMobile}
        mobileFullScreen
        {...getTaktAttributes(
          'aac-theme-modes-control-dropdown',
          chromeComponents.HEADER,
        )}
      >
        <DropdownItem
          value={ThemeModePreference.SYSTEM}
          {...getTaktAttributes(
            'aac-theme-modes-control-option-system',
            chromeComponents.HEADER,
            { themeModePreference: ThemeModePreference.SYSTEM },
          )}
        >
          {bundle.getMessage('theme-modes-control-system-label')}
        </DropdownItem>
        <DropdownItem
          value={ThemeModePreference.LIGHT}
          {...getTaktAttributes(
            'aac-theme-modes-control-option-light',
            chromeComponents.HEADER,
            { themeModePreference: ThemeModePreference.LIGHT },
          )}
        >
          {bundle.getMessage('theme-modes-control-light-label')}
        </DropdownItem>
        <DropdownItem
          value={ThemeModePreference.DARK}
          {...getTaktAttributes(
            'aac-theme-modes-control-option-dark',
            chromeComponents.HEADER,
            { themeModePreference: ThemeModePreference.DARK },
          )}
        >
          {bundle.getMessage('theme-modes-control-dark-label')}
        </DropdownItem>
      </Dropdown>
    </Flex>
  );
};

export default ThemeModesControl;
